// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("../node_modules/webpack-dev-server/client/index.js?protocol=ws%3A&hostname=0.0.0.0&port=3000&pathname=%2Fws&logging=info&overlay=true&reconnect=10&hot=true&live-reload=true");
__webpack_require__("../node_modules/webpack/hot/dev-server.js");
__webpack_require__("../node_modules/babel-polyfill/lib/index.js");
let __webpack_exports__ = __webpack_require__("./index.js");
